// Рядок нульової ціни (і значення за замовчуванням)
const ZERO_PRICE = '0.00';

// Від одиниці ціна показується як сума в доларах: рівно 2 знаки
const MIN_DOLLAR_PRICE = 1;
const DOLLAR_DECIMALS = 2;

// Від 0.1 до одиниці: рівно 4 знаки
const MIN_FIXED_SMALL_PRICE = 0.1;
const FIXED_SMALL_DECIMALS = 4;

// Ціна менша за 0.1: 3 значущі цифри після нулів, не більше 8 знаків
const SIGNIFICANT_DIGITS = 3;
const FALLBACK_DECIMALS = 6;
const MAX_DECIMALS = 8;

/**
 * Кількість знаків для ціни, меншої за 0.1 (як PEPE або SHIB).
 * @param {number | string} price
 * @returns {number}
 */
const getSmallPriceDecimals = (price) => {
  // Рахуємо кількість нулів після коми до першої значущої цифри
  const match = price.toString().match(/(\.0*)/);
  const decimalPlaces =
    match && match[1]
      ? match[1].length - 1 + SIGNIFICANT_DIGITS
      : FALLBACK_DECIMALS;

  return Math.min(decimalPlaces, MAX_DECIMALS);
};

/**
 * Форматує ціну: від одиниці 2 знаки й кома між тисячами (78,017.80),
 * від 0.1 до одиниці 4 знаки (0.5000), менші ціни зі значущими цифрами (0.0000123).
 * @param {number | string} price - Ціна для форматування.
 * @returns {string} - Відформатований рядок ціни.
 */
export const formatPrice = (price) => {
  const priceNumber = parseFloat(price);

  if (isNaN(priceNumber)) {
    return ZERO_PRICE; // Повертаємо значення за замовчуванням, якщо вхідні дані некоректні
  }

  // Нуль (ліквідація 1x Long) показуємо без зайвих знаків
  if (priceNumber === 0) {
    return ZERO_PRICE;
  }

  let decimalPlaces;

  if (priceNumber >= MIN_DOLLAR_PRICE) {
    decimalPlaces = DOLLAR_DECIMALS;
  } else if (priceNumber >= MIN_FIXED_SMALL_PRICE) {
    decimalPlaces = FIXED_SMALL_DECIMALS;
  } else {
    decimalPlaces = getSmallPriceDecimals(price);
  }

  return priceNumber.toLocaleString('en-US', {
    minimumFractionDigits: decimalPlaces,
    maximumFractionDigits: decimalPlaces,
  });
};
